import { render, staticRenderFns } from "./IconDangerCircle.vue?vue&type=template&id=7bacb36d"
import script from "./IconDangerCircle.vue?vue&type=script&lang=js"
export * from "./IconDangerCircle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports